<div #parent class="parent">
  <div class="language-picker">
    <ul>
      <li>
        <button
          [class.active]="language === 'javascript'"
          (click)="switchLanguage('javascript')"
        >
          Node.js
        </button>
      </li>
      <li>
        <button
          [class.active]="language === 'python'"
          (click)="switchLanguage('python')"
        >
          Python
        </button>
      </li>
      <li>
        <a href="https://docs.vertofx.com" target="_blank">PHP</a>
      </li>
      <li>
        <a href="https://docs.vertofx.com" target="_blank">Java</a>
      </li>
      <li>
        <a href="https://docs.vertofx.com" target="_blank">Go</a>
      </li>
    </ul>
  </div>
  <div class="code-container line-numbers">
    <button
      class="copy"
      (click)="copyCode()"
      [disabled]="isTyping"
      title="Copy code"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 9.675V12.825C12 15.45 10.95 16.5 8.325 16.5H5.175C2.55 16.5 1.5 15.45 1.5 12.825V9.675C1.5 7.05 2.55 6 5.175 6H8.325C10.95 6 12 7.05 12 9.675Z"
          fill="#969CA4"
        />
        <path
          d="M12.8253 1.5H9.67531C7.46288 1.5 6.37452 2.25121 6.08673 4.05369C5.99892 4.60363 6.4628 5.0625 7.01972 5.0625H8.32531C11.4753 5.0625 12.9378 6.525 12.9378 9.675V10.9806C12.9378 11.5375 13.3967 12.0014 13.9466 11.9136C15.7491 11.6258 16.5003 10.5374 16.5003 8.325V5.175C16.5003 2.55 15.4503 1.5 12.8253 1.5Z"
          fill="#969CA4"
        />
      </svg>
    </button>
    <pre
      aria-hidden="true"
      class="pre line-numbers"
      #pre
    ><code class="animate" [ngClass]="['code', 'language-' + language]" ></code>
  </pre>
  </div>
</div>
